module.exports = __webpack_public_path__ + "img/tenangodelvalle.cfd1dd04.jpg";